<template>
  <div ref="selectedVue" class="select-vue-sort">
    <div
      :class="{ 'select-vue-sort__face_active': open }"
      class="select-vue-sort__face"
      @click="open = !open"
    >
      <span v-html="getActiveName"></span>
      <svg>
        <use xlink:href="#svg-arrow-down"></use>
      </svg>
    </div>
    <SlideUpDown :model-value="open" :duration="500" class="select-vue-sort__list">
      <a
        v-for="(item, i) in getItems"
        :key="i"
        :href="item.request"
        :class="{ 'select-vue-sort__link_active': item.active }"
        class="select-vue-sort__link"
        @click.prevent="handlerChangeSort(item)"
        v-html="item.name"
      >
      </a>
    </SlideUpDown>
  </div>
</template>

<script>
import SlideUpDown from 'vue3-slide-up-down';

export default {
  name: 'SelectVueSort',
  components: {
    SlideUpDown,
  },
  props: {
    result: {
      type: Object,
    },
  },
  data() {
    return {
      open: false,
      objData: this.result.items,
    };
  },
  computed: {
    getItems() {
      return this.result.items.filter((el) => !el.active);
    },
    getActiveItem() {
      return this.result.items.find((el) => el.active);
    },
    getActiveName() {
      // return this.getActiveItem?.name || this.result?.messages?.placeholder;
      return (
        this.getActiveItem?.name ||
        this.result.items.find((el) => el.sort === 'property_POPULAR')?.name
      );
    },
  },
  watch: {
    open(prevValue) {
      if (prevValue) {
        document.addEventListener('click', this.handlerAnotherClick);
      } else {
        document.removeEventListener('click', this.handlerAnotherClick);
      }
    },
  },
  methods: {
    handlerChangeSort(item) {
      this.open = false;
      this.$router.replace(item.request);
      this.$emit('change', item.request);
    },
    handlerAnotherClick({ target }) {
      if (!target.closest('.select-vue-sort')) {
        this.open = false;
      }
    },
  },
};
</script>

<style lang="scss">
.select-vue-sort {
  display: flex;
  flex-direction: column;
  color: #757575;
  font-size: rem(16);
  position: relative;
  color: #757575;
  flex-grow: 1;
  @include point-md {
    text-align: right;
  }
  &__face {
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
    flex-grow: 1;
    @include point-md {
      color: #618eaf;
    }

    &:hover {
      cursor: pointer;
    }

    svg {
      width: 16px;
      height: 16px;
      transition: 0.2s linear transform;
      margin-left: 5px;
      margin-top: -20px;
      fill: currentColor;
      @include point-md {
        margin-top: 0px;
      }
    }

    span {
      flex-grow: 1;
    }

    &_active {
      svg {
        transform: rotate(180deg);
      }
    }
  }
  &__list {
    display: flex;
    flex-direction: column;
    position: absolute;
    z-index: 3;
    left: 0;
    right: 0;
    top: 100%;
    background-color: #fff;
    margin: 0 -16px;
    @include point-md {
      margin: 0;
    }
  }
  &__link {
    display: block;
    margin: 0 16px 16px;
    @include point-md {
      margin: 0 12px 12px;
    }
    &:hover {
      cursor: pointer;
    }

    &:first-child {
      margin-top: 12px;
    }

    :last-child {
      margin-bottom: 11px;
    }

    :first-child {
      margin-top: 11px;
    }
    &_active {
      color: #618eaf;
    }
  }
}
</style>
